import AddAppointmentContent from '../../../components/User/AddAppointment'
import Header from '../../../components/Layouts/User/Header'

const AddAppointment = () => {

    return (
        <>

            <AddAppointmentContent />

        </>
    )

}

export default AddAppointment